export default "__VITE_ASSET__9fff7bb2__"